import React, { useState } from 'react';
import { Palette } from 'lucide-react';

const ColorPicker = ({ label, value, onChange, presets = [] }) => {
  const [showPicker, setShowPicker] = useState(false);

  const defaultPresets = [
    '#ea6c0a', // Current orange
    '#B44105', // Orange B44105
    '#000000', // Black
    '#ffffff', // White
    '#374151', // Gray
    '#d97706', // Amber
  ];

  const colorPresets = presets.length > 0 ? presets : defaultPresets;

  return (
    <div className="space-y-2">
      <label className="block text-sm font-bold text-gray-700 font-inter">
        {label}
      </label>
      
      <div className="flex items-center gap-3">
        {/* Color Display */}
        <button
          type="button"
          onClick={() => setShowPicker(!showPicker)}
          className="w-12 h-10 rounded-lg border-2 border-gray-300 flex items-center justify-center hover:border-gray-400 transition-colors"
          style={{ backgroundColor: value }}
        >
          {!value && <Palette className="h-5 w-5 text-gray-400" />}
        </button>
        
        {/* Hex Input */}
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="#000000"
          className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent font-mono text-sm"
        />
      </div>
      
      {/* Color Presets */}
      {showPicker && (
        <div className="mt-3 p-4 bg-white border border-gray-200 rounded-lg shadow-lg">
          <p className="text-sm font-medium text-gray-700 mb-3">Choose a color:</p>
          <div className="grid grid-cols-5 gap-2 mb-4">
            {colorPresets.map((color, index) => (
              <button
                key={index}
                type="button"
                onClick={() => {
                  onChange(color);
                  setShowPicker(false);
                }}
                className="w-8 h-8 rounded-lg border-2 border-gray-300 hover:border-gray-400 transition-colors"
                style={{ backgroundColor: color }}
                title={color}
              />
            ))}
          </div>
          
          {/* HTML Color Input */}
          <div className="border-t pt-3">
            <label className="block text-xs text-gray-600 mb-1">Custom Color:</label>
            <input
              type="color"
              value={value || '#000000'}
              onChange={(e) => onChange(e.target.value)}
              className="w-full h-8 rounded border border-gray-300"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ColorPicker;